import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal, inject } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { PortfolioSettingsInterface } from '@shared/components/trading/portfolio/core/interfaces/portfolio-settings.interface'
import { WidgetsService } from '@modules/widgets-module/services/widgets.service'
import { PortfolioBlocksEnum } from '@shared/components/trading/portfolio/core/enums/portfolio-blocks.enum'
import { PortfolioBlocks } from '@shared/components/trading/portfolio/core/constants/portfolio-blocks'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import { DropdownColumnsActionsComponent } from '@shared/components/trading/widgets/common/dropdown-columns-actions/dropdown-columns-actions.component'
import { ColumnInterface } from '@shared/interfaces/column.interface'
import { PortfolioBlocksInterface } from '@shared/components/trading/portfolio/core/interfaces/portfolio-blocks.interface'

@UseLocales({ ru, en })
@Component({
	selector: 'app-portfolio-widget-actions',
	templateUrl: './portfolio-widget-actions.component.html',
	styleUrl: './portfolio-widget-actions.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [DropdownColumnsActionsComponent],
})
export class PortfolioWidgetActionsComponent {
	protected readonly portfolioBlocks: PortfolioBlocksInterface[] = PortfolioBlocks

	public widget: InputSignal<WidgetInterface<PortfolioSettingsInterface> | null> =
		input<WidgetInterface<PortfolioSettingsInterface> | null>(null)

	private readonly _widgetsService: WidgetsService = inject<WidgetsService>(WidgetsService)

	protected columns: Signal<ColumnInterface<PortfolioBlocksEnum>[]> = computed<
		ColumnInterface<PortfolioBlocksEnum>[]
	>((): ColumnInterface<PortfolioBlocksEnum>[] => {
		const widget: WidgetInterface<PortfolioSettingsInterface> | null = this.widget()
		if (!widget) return []

		return this.portfolioBlocks.map(
			({ block }: PortfolioBlocksInterface): ColumnInterface<PortfolioBlocksEnum> => ({
				column: block,
				visible: widget.settings.visible.includes(block),
			}),
		)
	})
	protected onChangeColumns(columns: ColumnInterface<PortfolioBlocksEnum>[]): void {
		const widget: WidgetInterface<PortfolioSettingsInterface> | null = this.widget()
		if (!widget) return

		const configurableBlocks: PortfolioBlocksEnum[] = this.portfolioBlocks.map(
			(b: PortfolioBlocksInterface): PortfolioBlocksEnum => b.block,
		)

		const alwaysVisible: PortfolioBlocksEnum[] = widget.settings.visible.filter(
			(b: PortfolioBlocksEnum): boolean => !configurableBlocks.includes(b),
		)

		const visible: PortfolioBlocksEnum[] = [
			...alwaysVisible,
			...columns
				.filter((col: ColumnInterface<PortfolioBlocksEnum>): boolean => col.visible)
				.map((col: ColumnInterface<PortfolioBlocksEnum>): PortfolioBlocksEnum => col.column),
		]

		this._widgetsService.updateWidget({
			...widget,
			settings: {
				...widget.settings,
				visible,
			},
		})
	}
}
